import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	plans: {
		defaultMessage: 'Plans',
		id: 'atlassian-navigation.plans.plans',
		description:
			'Dropdown title in the top bar navigation. Dropdown contains navigation links related to Plans',
	},
});
